import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import { RTC_TEST_URL, WEB_RTC_TEST_URL, MILLI_CAST_TEST_URL } from './utils';
import { isProd } from '../../utilities/UrlPaths';

const BroadcastLinks = () => {
  const { eventId } = useParams();
  const streamAlias = !isProd ? '-stage' : '';
  return (
    <Box className="need-more-help" sx={{ mt: 2, mb: 4 }}>
      <Typography variant="h6" fontWeight="bold">
        Need More Help?
      </Typography>
      <Typography>
        Here's a few helpful links in case you are having video connection issues:
      </Typography>
      <Box mt={2}>
        <Typography variant="subtitle2">
          Test your service connection and bandwidth:{' '}
          <a href={RTC_TEST_URL} target="__blank">
            {RTC_TEST_URL}
          </a>
        </Typography>
        <Typography variant="subtitle2">
          Verify browser compatibility:{' '}
          <a href={WEB_RTC_TEST_URL} target="__blank">
            {WEB_RTC_TEST_URL}
          </a>
        </Typography>
        <Typography variant="subtitle2">
          Millicast viewer:{' '}
          <a href={`${MILLI_CAST_TEST_URL}/${eventId + streamAlias}`} target="__blank">
            {`${MILLI_CAST_TEST_URL}/${eventId}`}
          </a>
        </Typography>
      </Box>
    </Box>
  );
};
export default BroadcastLinks;
